var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43605 1.22107C6.13838 1.51875 6.13838 2.00247 6.43605 2.30014L15.943 11.7885L6.43606 21.2955C6.13838 21.5932 6.13838 22.0769 6.43606 22.3746C6.73373 22.6722 7.21745 22.6722 7.51513 22.3746L17.543 12.3467C17.6919 12.1978 17.7663 12.0118 17.7663 11.8071C17.7663 11.6211 17.6919 11.4164 17.543 11.2676L7.51513 1.23968C7.21745 0.923401 6.73373 0.923399 6.43605 1.22107Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.2d009d09ad92c046b4fc84817f48a637.svg";
export { ForwardRef as ReactComponent };